import React from 'react';
import DrMaxPharmacyListItem, { Pharmacy } from './DrMaxPharmacyListItem';
import styles from './DrMaxPharmacyList.module.scss';

interface Props {
	items: Pharmacy[];
	onItemSelect: (item: Pharmacy) => void;
}

const DrMaxPharmacyList: React.FC<Props> = ({ items, onItemSelect }) => {
	return (
		<div className={styles.wrapper}>
			{items.map((item, index) => {
				return (
					<React.Fragment key={index}>
						<DrMaxPharmacyListItem item={item} onItemSelect={onItemSelect} />
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default DrMaxPharmacyList;
